import Table, { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { getOnlinePaymentReport } from '../../api/api';
import Spinner from "../../components/_common/Spinner";
import { errorNotify } from "../../services/toast.notification";
import './style.css';
import { ConfigProvider } from "antd";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import moment from 'moment';

export interface InputProps {
  url: any
}

const OnlinePaymentReport = ({ url }: InputProps) => {

  const columns: ColumnsType<any> = [
    { title: 'شماره فاکتور', dataIndex: 'Prk_OnlinePaymentInvoice_AutoID', key: 'Prk_OnlinePaymentInvoice_AutoID' },
    { title: 'درگاه بانک ', dataIndex: 'Str_BankName', key: 'Str_BankName' },
    { title: 'شماره پذیرش ', dataIndex: 'str_AdmitID', key: 'str_AdmitID' },
    { title: 'ارسالی', dataIndex: 'Str_ContractorName', key: 'Str_ContractorName' },
    { title: ' مبلغ', dataIndex: 'Int_Amount', key: 'Int_Amount' },
    { title: 'وضعیت فاکتور', dataIndex: 'str_TransactionState', key: 'str_TransactionState' },
    { title: 'کد ترمینال', dataIndex: 'Str_TerminalCode', key: 'Str_TerminalCode' },
    { title: 'کد فروشنده', dataIndex: 'Str_MerchantCode', key: 'Str_MerchantCode' },
    { title: 'کد تراکنش', dataIndex: 'Str_TransactionReferenceID', key: 'Str_TransactionReferenceID' },
    { title: 'کد رهگیری', dataIndex: 'Str_TraceNumber', key: 'Str_TraceNumber' },
    { title: 'کد مرجع', dataIndex: 'Str_ReferenceNumber: ', key: 'Str_ReferenceNumber: ' },
    { title: 'ساعت درخواست', dataIndex: 'Str_LogCreateDateTime', key: 'Str_LogCreateDateTime' },
    { title: 'استعلام', dataIndex: 'str_CheckPaymentResult', key: 'str_CheckPaymentResult' },
    { title: 'ساعت CheckPayment', dataIndex: 'Str_LogCheckPaymentDateTime', key: 'Str_LogCheckPaymentDateTime' },
    { title: 'استعلام VerifyPayment', dataIndex: 'str_VerifyPaymentResult', key: 'str_VerifyPaymentResult' },
    { title: 'ساعت VerifyPayment', dataIndex: 'Str_LogVerifyPaymentDateTime', key: 'Str_LogVerifyPaymentDateTime' },
    { title: 'ساعت ثبت DB', dataIndex: 'Str_ApplyPaymentOnDBDateTime', key: 'Str_ApplyPaymentOnDBDateTime' },
  ];


  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [firstDate, setFirstDate] = useState<any>(undefined);
  const [lastDate, setLastDate] = useState<any>(undefined);
  const [successCount, setSuccessCount] = useState(0)
  const [failedCount, setFailedCount] = useState(0);

  const _getOnlinePaymentReport = (firstDateEn:string,lastDateEn:string) => {
    setIsLoading(true);
    getOnlinePaymentReport(url, firstDateEn, lastDateEn)
      .then((result: any) => {
        setData(result);
        var successCnt = result.filter((item: any) => {
          return item.Bit_CheckPaymentResult == true;
        }).length;
        setSuccessCount(successCnt);

        var failedCnt = result.filter((item: any) => {
          return item.Bit_CheckPaymentResult == false;
        }).length
        setFailedCount(failedCnt);

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage, undefined, 5000)
      })
  }

  const onChangeDatePicker = (dates:any,dateStrings:any) => {

    console.log(dates);
    if (!dateStrings) return;
    if (dateStrings.length < 2) return;
    if (dateStrings[0] === "") return;
    if (dateStrings[1] === "") return;

    setFirstDate(dates[0])
    setLastDate(dates[1])

    

    _getOnlinePaymentReport(dates[0].format('YYYY-MM-DD'),dates[1].format('YYYY-MM-DD'));
}

  useEffect(() => {

     //_getOnlinePaymentReport(url);
     //moment(Date.now()).locale("en").format("YYYY/MM/DD")
  }, [])

  return (
    <div className="tab-content-padding">
      <center style={{ paddingTop: '15px' }}>
        <div className="calender" >
          <ConfigProvider locale={fa_IR} direction="rtl">
            <JalaliLocaleListener />
            <DatePickerJalali.RangePicker value={[firstDate, lastDate]} onCalendarChange={(dates: any, dateStrings: any) => onChangeDatePicker(dates, dateStrings)} />
          </ConfigProvider>
        </div>
      </center>
      {
        isLoading === false && (
          <>
            {data.length > 0 && (
              <>
                <div className="inner-tabs_content">
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:"5px"}}>
                    <span style={{ color: "green" }}>پرداخت های موفق: {successCount}</span>
                    <span style={{ color: "red" }}>پرداخت های ناموفق: {failedCount}</span>
                  </div>
                  <Table scroll={{ x: 1500 }}
                    dataSource={data} columns={columns}
                  />
                </div>
              </>
            )}
            {data.length == 0 && (
              <p className="empty-data">داده ای برای نمایش موجود نیست.</p>
            )

            }
          </>
        )
      }
      {
        isLoading === true && (
          <Spinner />
        )
      }
    </div>

  )
}
export default OnlinePaymentReport;
